import React, { useEffect, useState } from "react";
import Loader from "../Common/Loader";
import { Link } from "react-router-dom";
import CommonService from "../../services/common.service";

const MyPlayers = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [rounData, setRounData] = useState([]);
  const [searchPlayerName, setSearchPlayerName] = useState("");
  const [sortOrder, setSortOrder] = useState("asc"); // Initial sorting order
  const [sortColumn, setSortColumn] = useState(null);
  const [playersData, setPlayersData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const perPage = 10; // Number of items per page

  useEffect(() => {
    CommonService.myPlayerContribution(searchPlayerName, sortOrder, currentPage)
      // .then((response) => response.json())
      .then((result) => {
        setPlayersData(result.data);
        setRounData(result.rounData);
        setTotalPages(result.last_page);
        setIsLoading(false);
      });
  }, [searchPlayerName, sortOrder, currentPage]);
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };
  // const pageNumbers = []
  // for (let i = currentPage - 3; i <= currentPage + 3; i++) {
  //   if (i > 0 && i <= totalPages) {
  //     pageNumbers.push(i)
  //   }
  // }

  const handleSort = (column) => {
    if (sortColumn === column) {
      // If the same column is clicked, reverse the sorting order
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      // If a different column is clicked, set the new column and sorting order
      setSortColumn(column);
      setSortOrder("asc"); // Default to ascending
    }
  };

  const sortedPlayersData = [...playersData]; // Create a copy to avoid modifying the original data

  // Sort the player data based on the selected column and sorting order
  if (sortColumn) {
    sortedPlayersData.sort((a, b) => {
      if (sortColumn === "player") {
        // Sort by player name
        const nameA = a.player_name.toLowerCase();
        const nameB = b.player_name.toLowerCase();
        return sortOrder === "asc"
          ? nameA.localeCompare(nameB)
          : nameB.localeCompare(nameA);
      } else if (sortColumn === "points") {
        // Sort by player total points
        return sortOrder === "asc"
          ? a.player_total - b.player_total
          : b.player_total - a.player_total;
      } else if (sortColumn === "cont") {
        // Sort by contribution percentage
        return sortOrder === "asc"
          ? a.player_contr - b.player_contr
          : b.player_contr - a.player_contr;
      } else {
        // Sort by round data
        return sortOrder === "asc"
          ? a.round[sortColumn - 1].points - b.round[sortColumn - 1].points
          : b.round[sortColumn - 1].points - a.round[sortColumn - 1].points;
      }
    });
  }
  const [isActive, setActive] = useState(false);

  const handleToggle = () => {
    setActive(!isActive);
  };
  return (
    <div className="middle-section">
      <div className="container">
        <div className="innerwhite-section">
          <div className="heading">
            <h2>My Players</h2>
          </div>

          {isLoading ? (
            <Loader />
          ) : (
            <>
              <div className="tab-content" id="myTabContent">
                <div className="searchfilter">
                  Contribution &nbsp;
                  <div
                    className={
                      isActive ? "custom-searchbox open" : "custom-searchbox"
                    }
                  >
                    <Link to="" className="searchicon" onClick={handleToggle}>
                      <img src="images/search-icon.png" alt="img" />
                    </Link>
                    <div className="searchbox">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search by player or team name"
                        value={searchPlayerName}
                        onChange={(e) => setSearchPlayerName(e.target.value)} // Update searchPlayerName state
                      />

                      <Link href="" className="closeicon">
                        <img
                          src="images/close-icon-blue.png"
                          alt="img"
                          onClick={handleToggle}
                        />
                      </Link>
                    </div>
                  </div>
                </div>
                {/* <div
                  className="customscroll pt-3"
                  style={{ maxHeight: "500px", overflowY: "auto" }}
                > */}
                <div
                  className="my-players-table-container"
                  style={{ maxHeight: "500px", overflowY: "auto" }}
                >
                  <table
                    className="table my-players-mytable"
                    style={{ maxHeight: "600px" }}
                  >
                    <thead>
                      <tr>
                        <th
                          className="fixed-column"
                          onClick={() => handleSort("player")}
                        >
                          Player
                          {sortColumn === "player" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th onClick={() => handleSort("points")}>
                          Points
                          {sortColumn === "points" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th onClick={() => handleSort("cont")}>
                          Cont%
                          {sortColumn === "cont" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        {rounData.map((item, key1) => (
                          <th key={key1} onClick={() => handleSort(item.round)}>
                            R{item.round}
                            {sortColumn === item.round && (
                              <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                            )}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {sortedPlayersData &&
                        sortedPlayersData.map((item, key) => (
                          <tr key={key}>
                            <td className="fixed-column">
                              <div className="playerinfo">
                                <Link
                                  to={`/player-profile/${item.player_id}`}
                                  className="playermoreinfo"
                                  style={{
                                    color: "#000000",
                                    fontWeight: "600",
                                    fontSize: "15px",
                                  }}
                                >
                                  <div className="playerimg">
                                    <figure title={item.full_name}>
                                      {item?.is_avatar === 1 ? (
                                        <img
                                          src={`${process.env.REACT_APP_PLAYER_AVATAR_URL}${item.image}`}
                                          alt="img"
                                        />
                                      ) : (
                                        <img
                                          src={`${process.env.REACT_APP_UPLOAD_URL}player/${item.image}`}
                                          alt="img"
                                        />
                                      )}
                                    </figure>
                                  </div>
                                  <div
                                    className="playername"
                                    style={{
                                      whiteSpace: "normal",
                                      maxWidth: "117px",
                                    }}
                                  >
                                    <span>
                                      <span title={item.player_name}>
                                        {item.player_name}
                                      </span>
                                    </span>
                                  </div>
                                </Link>
                              </div>
                            </td>
                            <td>{item.player_total}</td>
                            <td>{item.player_contr}%</td>
                            {item.round &&
                              item.round.map((item, key1) => (
                                <td key={key1}>{item?.points}</td>
                              ))}
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default MyPlayers;
